import * as types from './mutation-types.js';
import {setCookie, removeCookie, setLocalStorage, removeLocalStorage, getAge} from '@/common/js/utils.js';

export const loginOut = function ({commit}) {
	removeCookie('token');
	removeLocalStorage('user');
	commit(types.SET_TOKEN, '');
	commit(types.SET_USERINFO, null);
	commit(types.RESET_CLASS_STATE);
};

export const saveToken = function ({commit}, token) {
	commit(types.SET_TOKEN, setCookie('token', token));
};

export const removeToken = function ({commit}) {
	removeCookie('token');
	commit(types.SET_TOKEN, '');
};

export const saveBackurl = function ({commit}, backurl) {
	setCookie('backurl', backurl);
	commit(types.SET_BACK_URL, backurl);
};

export const removeBackurl = function ({commit}) {
	removeCookie('backurl');
	commit(types.SET_BACK_URL, '');
};

export const setWxUrl = function ({commit}, url) {
	commit(types.SET_WX_URL, url);
};

export const saveUserInfo = function ({commit}, userInfo) {
	if (!userInfo.age && userInfo.birthDate) {
		userInfo.age = getAge(userInfo.birthDate);
	}
	if (!userInfo.headImg && userInfo.headPic) {
		userInfo.headImg = userInfo.headPic;
	}
	setLocalStorage('user', JSON.stringify(userInfo));
	commit(types.SET_USERINFO, userInfo);
};

export const removeUserInfo = function ({commit}) {
	removeLocalStorage('user');
	commit(types.SET_USERINFO, null);
};

export const startVerifyCodeTiem = function ({commit, getters}) {
	if (!getters.isVerifyCodeReady) {
		return;
	}
	commit(types.SET_VERIFY_CODE_STATE, false);
	let timer = window.setInterval(function () {
		let time = getters.verifyCodeTime - 1;
		if (time <= 0) {
			window.clearInterval(timer);
			commit(types.SET_VERIFY_CODE_STATE, true);
			commit(types.SET_VERIFY_CODE_TIME, 60);
		} else {
			commit(types.SET_VERIFY_CODE_TIME, time);
		}
	}, 1000);
};

export const resetClass = function ({commit}) {
	commit(types.RESET_CLASS_STATE);
};

export const startClass = function ({commit}) {
	commit(types.SET_START_CLASS);
};

export const endClass = function ({commit}) {
	commit(types.SET_END_CLASS);
};

export const setStartClassRecordId = function ({commit}, recordId) {
	commit(types.SET_START_CLASS_RECORDID, recordId);
};

export const setLoadingCount = function ({commit}, count) {
	commit(types.SET_LOADING_COUNT, count);
};



// WEBPACK FOOTER //
// ./src/store/action.js